<template>
    <el-dialog
        title="Add a new Receiver"
        width="900px"
        :visible="show"
        :before-close="beforeClose"
    >
        <el-form
            :model="form"
            ref="form"
            label-width="150px"
            label-position="right"
            :rules="rules"
            v-loading="processing"
        >
            <el-form-item label="User" prop="display_name">
                <el-autocomplete
                    popper-class="authenticate-autocomplete"
                    v-model="form.display_name"
                    :fetch-suggestions="searchUser"
                    placeholder="Type in name"
                    @select="onUserSelect"
                >
                    <i class="el-icon-edit el-input__icon" slot="suffix"></i>
                    <template slot-scope="{ item }">
                        <div class="display_name">{{ item.display_name||item.email }}</div>
                        <span class="email">{{ item.email }}</span>
                    </template>
                </el-autocomplete>
            </el-form-item>
            <el-form-item label="Total amount" prop="total_amount">
                <el-input
                    v-model="form.total_amount"
                    autocomplete="off"
                    placeholder="Total amount"
                    type="number"
                    clearable
                >
                    <template slot="append">{{asset_name}}</template>
                </el-input>
            </el-form-item>
            <el-form-item label="Fee amount" prop="fee_amount">
                <el-input
                    v-model="form.fee_amount"
                    autocomplete="off"
                    placeholder="Fee amount"
                    type="number"
                    clearable
                >
                    <template slot="append">{{asset_name}}</template>
                </el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer" v-loading="processing">
            <el-button @click="onCancelClick">Cancel</el-button>
            <el-button @click="onSubmit" type="primary">Save</el-button>
        </div>
    </el-dialog>
</template>

<script>
import { mapActions } from "vuex";
import Big from 'big.js';

export default {
    name: "NewReceiver",
    props: {
        asset_name: String,
        show: { default: false },
        onSelect: Function,
        onClose: Function
    },
    data() {
        return {
            items: [],
            form: {
                display_name: "",
                authenticate_id: "",
                fee_amount: 0,
                total_amount: 0
            },
            processing: false,
            rules: {
                total_amount: [
                    {
                        required: true,
                        message: "Net amount is required",
                        trigger: "blur"
                    }
                ],
                fee_amount: [
                    {
                        required: true,
                        message: "Fee amount is required",
                        trigger: "blur"
                    }
                ]
            }
        };
    },
    watch: {},
    mounted() {
        this.loadCurrenciesData();
    },
    computed: {
        result() {
            return {
                authenticate_id: this.form.authenticate_id,
                display_name: this.form.display_name,
                fee_amount: this.form.fee_amount,
                total_amount: this.form.total_amount,
                net_amount: Number((new Big(this.form.total_amount).minus(new Big(this.form.fee_amount)))),
            }
        }
    },
    methods: {
        ...mapActions(["request", "getError"]),
        beforeClose(done = () => {}) {
            this.form.authenticate_id = "";
            this.form.net_amount = 0;
            this.form.fee_amount = 0;
            this.form.display_name = "";
            done();
        },
        onCancelClick() {
            this.onClose();
        },
        loadCurrenciesData() {
            let ctrl = this;
            ctrl.processing = true;
            ctrl.request({
                method: "GET",
                endpoint: `currencies?limit=100&where=enabled=1`
            })
                .then(({ data = {} }) => {
                    ctrl.asset_names = data.results.map(d => {
                        return d.asset_name;
                    });
                })
                .catch(err => {
                    ctrl.getError({
                        err,
                        title: "CURRENCY_ERROR",
                        message: "Get currency Failed"
                    }).then(ctrl.$notify);
                })
                .finally(() => {
                    ctrl.processing = false;
                });
        },
        searchUser(queryString = "", callback = () => {}) {
            let ctrl = this;
            if (!queryString || queryString.trim().length == 0) {
                callback([]);
                return;
            }
            ctrl.processing_search = true;
            let query = `authenticate?
                limit=10&where=activated=1 
                AND disabled=0 `;
            if (queryString.trim().length > 0) {
                query += ` AND (display_name LIKE '%${queryString}%' OR email LIKE '%${queryString}%') `;
            }

            let endpoint = encodeURI(query);

            ctrl.request({
                method: "GET",
                endpoint
            })
                .then(({ data = {} }) => {
                    callback(data.results);
                })
                .catch(err => {
                    ctrl.getError({
                        err,
                        title: "PERMISSION_ERROR",
                        message: "Get permission level Failed"
                    }).then(ctrl.$notify);
                })
                .finally(() => {
                    ctrl.processing_search = false;
                });
        },
        onUserSelect(item) {
            this.form.display_name = item.display_name;
            this.form.authenticate_id = item.id;
        },
        onSubmit() {
            this.onSelect(this.result);
            this.onCancelClick();
        }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.permission-detail-item {
    display: flex;
    line-height: 26px;
    border-bottom: 1px solid #ccc;
}
.permission-detail-form-settings {
    border: 1px solid #ccc;
}
.permission-detail-item .title {
    width: 200px;
    text-align: right;
    background-color: rgba(0, 0, 0, 0.1);
    border-right: 1px solid #ccc;
}

.permission-detail-item .title span {
    padding: 0 8px;
}
.permission-detail-item .value {
    flex: 1;
}
.permission-detail-item .value span {
    padding: 0 8px;
}

.permission-detail-item:last-child {
    border-bottom: none;
}
</style>
<style>
.authenticate-autocomplete li {
    line-height: 1.5em;
    padding: 7px;
}

.authenticate-autocomplete .display_name {
    text-overflow: ellipsis;
    overflow: hidden;
}
.authenticate-autocomplete .email {
    font-size: 12px;
    color: #b4b4b4;
}

.highlighted .email {
    color: #ddd;
}
</style>